module.exports = __webpack_public_path__ + "img/logo-no-text.e68fb4b0.svg";